import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import styles from './Announcements.module.scss';
import { useDispatch } from 'react-redux';
import { openModal, toggleWelcomeGuideVisibility } from '@actions/ui';
import analytics from '@support/analytics';

const handleExternalLink = (_: string, e: MouseEvent) => {
  e?.stopPropagation();
  analytics.track(`Activity Link Tapped`);
};

const ReferralLink = ({ children }) => {
  const dispatch = useDispatch();

  return (
    <span className={styles.inlineBtn} onClick={() => dispatch(openModal('shareInvite'))}>
      {children}
    </span>
  );
};

const BookletLink = ({ children }) => {
  const dispatch = useDispatch();

  return <a onClick={() => dispatch(toggleWelcomeGuideVisibility(true))}>{children}</a>;
};

const ClayLink = ({ children, ...props }) => {
  // @ts-ignore
  const [_, actionOrLocation, id] = (props.node?.properties?.href || '').match(
    /clay-app:\/\/([a-zA-Z0-9]+)\/?([a-zA-Z0-9\-]+)?/,
  );

  switch (actionOrLocation) {
    case 'referral':
      return <ReferralLink>{children}</ReferralLink>;

    case 'welcomeBooklet':
      return <BookletLink>{children}</BookletLink>;

    default:
      return null;
  }
};

const renderLink = (
  // analyticsType: string | undefined,
  { children, ...props },
) => {
  if (props.node?.properties?.href?.startsWith('clay-app://')) {
    return <ClayLink {...props}>{children}</ClayLink>;
  }

  if (props.node?.properties?.href === 'null') {
    return children;
  }

  return (
    <a onClick={handleExternalLink.bind(null, 'Activity')} href={props.href} target="_blank">
      <span className={`${styles.link} feed-link`}>{children}</span>
    </a>
  );
};

const renderCollapsedParagraphs = ({ children }) => {
  return <>{children}&nbsp;</>;
};

const renderCollapsedUnorderedList = ({ children }) => {
  return <>{children}</>;
};

const renderCollapsedOrderedList = ({ children }) => {
  return <>{children}</>;
};

const renderCollapsedListItem = ({ children }) => {
  return <>{children}&nbsp;</>;
};

const CollapsedParagraphContentWrapper = ({ children }) => <p>{children}</p>;

export default function renderMarkdown(content: string, collapseBlocks?: boolean) {
  const Wrapper = collapseBlocks ? CollapsedParagraphContentWrapper : React.Fragment;

  return (
    <Wrapper>
      <ReactMarkdown
        children={content}
        linkTarget="_blank"
        components={{
          a: renderLink,
          ...(collapseBlocks
            ? {
                p: renderCollapsedParagraphs,
                ul: renderCollapsedUnorderedList,
                ol: renderCollapsedOrderedList,
                li: renderCollapsedListItem,
              }
            : {}),
        }}
        remarkPlugins={[remarkGfm]}
      />
    </Wrapper>
  );
}
